import CallRoundedIcon from "@mui/icons-material/CallRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import { useNextT } from "../../i18n";
import { callHref, SUPPORT_PHONE, textHref, whatsappHref } from "../paths";
import s from "../contactUs.module.scss";

/** Call / WhatsApp / Text: three large choices that come before the form (board 193). One number for everyone. */
export const TalkButtons = () => {
  const { t } = useNextT();
  return (
    <div className={s.talk}>
      <a className={s.talkBtn} href={callHref} aria-label={`${t("contactUs.call")} ${SUPPORT_PHONE}`}><CallRoundedIcon aria-hidden />{t("contactUs.call")}</a>
      <a className={s.talkBtn} href={whatsappHref} target="_blank" rel="noopener noreferrer"><WhatsAppIcon aria-hidden />{t("contactUs.whatsapp")}</a>
      <a className={s.talkBtn} href={textHref}><SmsOutlinedIcon aria-hidden />{t("contactUs.text")}</a>
    </div>
  );
};
